/**
 * summonerSpellVfxSpecs — Pure descriptors for D/F cast feedback (no THREE).
 * Playable S2 spells only — Smite/TP are stub (no VFX) per AB-10 policy.
 */
export const SUMMONER_VFX_SPECS = {
  flash: { id: 'flash', color: 0xfde047, duration: 0.35, anchor: 'flash_path', scale: 1.2, shape: 'sphere' },
  ignite: { id: 'ignite', color: 0xef4444, duration: 0.55, anchor: 'target', scale: 0.95, shape: 'flame' },
  heal: { id: 'heal', color: 0x4ade80, duration: 0.45, anchor: 'caster', scale: 1.4, shape: 'ring' },
  ghost: { id: 'ghost', color: 0x67e8f9, duration: 0.5, anchor: 'caster', scale: 1.15, shape: 'trail' },
  barrier: { id: 'barrier', color: 0xfbbf24, duration: 0.5, anchor: 'caster', scale: 1.65, shape: 'shield' },
  exhaust: { id: 'exhaust', color: 0xa855f7, duration: 0.45, anchor: 'target', scale: 1.05, shape: 'ring' },
  cleanse: { id: 'cleanse', color: 0xf8fafc, duration: 0.4, anchor: 'caster', scale: 1.1, shape: 'column' },
  clarity: { id: 'clarity', color: 0x3b82f6, duration: 0.45, anchor: 'caster', scale: 1.0, shape: 'spark' }
};

export function getSummonerVfxSpec(spellId) {
  return SUMMONER_VFX_SPECS[spellId] || null;
}
